module.exports = __webpack_public_path__ + "img/JFOODO.1666989d.jpg";